module.exports = __webpack_public_path__ + "img/f796aa4.png";